/* printJobs.js — submit print jobs to the in-app remote-print queue.
 *
 * Use this when the user is away from the store (e.g. doing a GRV from home)
 * and wants the printer at the store to fire the print. The store keeps one
 * tab open on /print-station which polls and auto-prints.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitPrintJob({
  jobType = "html",
  title,
  html,
  pageSizeHint = null,
  copies = 1,
  createdBy = null,
  sourceType = null,
  sourceId = null,
  sourceNumber = null,
}) {
  const { data } = await axios.post(`${API}/print-jobs`, {
    job_type: jobType,
    title,
    html,
    page_size_hint: pageSizeHint,
    copies,
    created_by: createdBy,
    source_type: sourceType,
    source_id: sourceId,
    source_number: sourceNumber,
  });
  return data;
}
